import { gql } from '@apollo/client';

export const META_QUERY = gql`
	query meta($key: String, $workplaceId: UUID) {
		meta(key: $key, workplaceId: $workplaceId) {
			id
			key
			value
		}
	}
`;
